import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createDisplayOurProductsScreenIntent(urlKey: string): WebViewIntent {
  return createIntent('DISPLAY_OUR_PRODUCTS_SCREEN', {
    urlKey,
  })
}
